import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'scrTeacherFilter'
})
export class SCRTeacherPipe implements PipeTransform {

    transform(arrayObj: any[], requirementId: number, courseId: number, preferredTeacher: number, preferredTeacherNameSetByCounselor: string): any {
        const returnObject = arrayObj.filter(x => x.DistrictRequirement_ID == requirementId && x.CourseId == courseId);

        // if the counselor selected a preferred Teacher not in the current options list, add it
        if (preferredTeacher) {
            const tmpObj = {
                CourseId: courseId,
                DistrictRequirement_ID: requirementId,
                TextField: preferredTeacherNameSetByCounselor,
                ValueField: preferredTeacher
            };
            const tObj = returnObject.find(x => x.TextField == preferredTeacherNameSetByCounselor && x.ValueField == preferredTeacher);
            if (!tObj) {
                returnObject.push(tmpObj);
            }
        }
        const blankObj = {
            CourseId: courseId,
            DistrictRequirement_ID: requirementId,
            TextField: '',
            ValueField: ''
        };
        const cObj = returnObject.find(x => x.TextField.trim() == '' && x.ValueField.trim() == '');
        if (!cObj) {
            returnObject.splice(0,0, blankObj);
        }
        return returnObject;
    }

}
